// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/languages.js';

import { paths } from '../generated/languages';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('languages', Original, paths);
